/**
 * Title and input placeholder a do-chat locale starts with, written in its language: both are
 * required in a locale config, and a theme created with the orchestrator has no locale holding
 * them yet.
 */
export const DEFAULT_LOCALE_TEXTS = {
  de_DE: { title: "Name des Agenten", placeholder: "Geben Sie hier Ihre Nachricht ein…" },
  en_EN: { title: "Agent name", placeholder: "Enter your message here…" },
  es_ES: { title: "Nombre del agente", placeholder: "Escribe aquí tu mensaje…" },
  fr_FR: { title: "Nom de l'agent", placeholder: "Entrez ici votre message…" },
  it_IT: { title: "Nome dell'agente", placeholder: "Scrivi qui il tuo messaggio…" },
  nl_NL: { title: "Naam van de agent", placeholder: "Typ hier je bericht…" },
};

export const getDefaultLocaleTexts = (locale: string) =>
  DEFAULT_LOCALE_TEXTS[locale as keyof typeof DEFAULT_LOCALE_TEXTS] ?? DEFAULT_LOCALE_TEXTS.en_EN;
